import { jsx as _jsx } from "react/jsx-runtime";
import { ArrowALeftIcon } from '@skbkontur/icons/icons/ArrowALeftIcon/ArrowALeftIcon';
import { ToolPencilLineIcon } from '@skbkontur/icons/icons/ToolPencilLineIcon/ToolPencilLineIcon';
import { Button } from '@skbkontur/react-ui';
export const ModeSwitch = ({ mode, onModeCnage, labelManual, labelAuto }) => {
    const toogleMode = () => {
        onModeCnage(mode === 'auto' ? 'manual' : 'auto');
    };
    if (mode === 'auto') {
        return (_jsx(Button, { use: "link", icon: _jsx(ToolPencilLineIcon, {}), onClick: toogleMode, children: labelManual }));
    }
    return (_jsx(Button, { use: "link", icon: _jsx(ArrowALeftIcon, {}), onClick: toogleMode, children: labelAuto }));
};
